<template>
  <div>
    <b-card>
      <b-tabs>
        <b-tab title="Layout Wdma Hist">
          <b-form class="custom-form" @submit.prevent>
            <b-row>
              <!-- <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="_id" placeholder="_ID" v-model="form._id" disabled />
                  <label for="_id">_ID</label>
                </div>
              </b-col> -->
              <b-col md="12"></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="email" placeholder="Email" v-model="form.email" disabled/>
                  <label for="email">Email</label>
                </div>
              </b-col>
              


              <b-col md="12">
                  <label>Layout</label>
                <div class="form-label-group">
                  <b-form-textarea
                    id="layout"
                    placeholder="Layout"
                    rows="5"
                    v-model="form.layout"
                  />
                </div>
              </b-col>
              <b-col md="12">
                <label>Metadata</label>
                <div class="form-label-group">
                  <b-form-textarea
                    id="metadata"
                    placeholder="Metadata"
                    rows="5"
                    v-model="form.metadata"
                  />
                </div>
              </b-col>

              <b-col md="12">
                  <label for="text">Layout Mobile</label>
                <div class="form-label-group">
                  <b-form-textarea
                    id="layout_mobile"
                    placeholder="Layout"
                    rows="5"
                    v-model="form.layout_mobile"
                  />
                </div>
              </b-col>
              <b-col md="12">
                  <label for="text">Metadata Mobile</label>
                <div class="form-label-group">
                  <b-form-textarea
                    id="metadata_mobile"
                    placeholder="Metadata"
                    rows="5"
                    v-model="form.metadata_mobile"
                  />
                </div>
              </b-col>

              <b-col class="mb-2" md="12"><hr /></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-created"
                    placeholder="Data Criação"
                    v-model="form.dt_create"
                    disabled
                  />
                  <label for="dt-created">Data Criação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-created"
                    placeholder="Email Criação"
                    v-model="form.email_create"
                    disabled
                  />
                  <label for="email-created">Email Criação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-update"
                    placeholder="Data Alteração"
                    v-model="form.dt_update"
                    disabled
                  />
                  <label for="dt-update">Data Alteração</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-update"
                    placeholder="Email Alteração"
                    v-model="form.email_update"
                    disabled
                  />
                  <label for="email-update">Email Alteração</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-delete"
                    placeholder="Data Desativação"
                    v-model="form.dt_delete"
                    disabled
                  />
                  <label for="dt-delete">Data Desativação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-delete"
                    placeholder="Email Desativação"
                    v-model="form.email_delete"
                    disabled
                  />
                  <label for="email-delete">Email Desativação</label>
                </div>
              </b-col>
              
              <b-col>
                <!-- <b-button type="submit" variant="primary" class="mr-1" @click="onSubmit">
                  Enviar
                </b-button> -->
                <b-button
                  variant="danger"
                  class="mr-1"
                  @click="onBackPage"
                >
                  Voltar
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormInput,
  BForm,
  BButton,
  BTabs,
  BTab,
  BCard,
  BFormTextarea
} from "bootstrap-vue";
import layoutService from "@/providers/layoutService";
import convertDatetimeHelper from '@/helpers/convert-datetime-helper';
// import messagesNotifyHelper from '@/helpers/messages-notify-helper';
import AppConstants from '@/appConstants';

export default {
  props: {},
  data() {
    return {
      dataID: null,
      form: {
        _id: "",
        email: "",
        layout: {},
        metadata: {},
        layout_mobile: {},
        metadata_mobile: {},
        dt_create: "",
        dt_update: "",
        dt_delete: "",
        email_create: "",
        email_update: "",
        email_delete: "",
      },
    };
  },
  created() {
    this.$store.dispatch("admin/updatePageTitle", 'Layout Wdma Hist');
    if (this.isUpdate) {
      this.dataID = this.$route.params.id;
      // console.log("dataid: ", this.dataID);
    }

    this.getDetails();
  },
  watch: {},
  computed: {
    isUpdate() {
      if (this.$route.params.id) {
        return true;
      }
      return false;
    },
  },
  methods: {
    onBackPage() {
      this.$router.push(AppConstants.NAVIGATION_PAGE_ADM_LAYOUT_WDMA_HIST);
    },
    onSubmit() {
      // const postForm = JSON.parse(JSON.stringify(this.form));
      // if (postForm.layout) {
      //   postForm.layout = JSON.parse(postForm.layout);
      // }
      // if (postForm.metadata) {
      //   postForm.metadata = JSON.parse(postForm.metadata);
      // }
      // if (postForm.layout_mobile) {
      //   postForm.layout_mobile = JSON.parse(postForm.layout_mobile);
      // }
      // if (postForm.metadata_mobile) {
      //   postForm.metadata_mobile = JSON.parse(postForm.metadata_mobile);
      // }
      // layoutService
      //   .registerLayout(postForm, new URLSearchParams())
      //   .then(() => {
      //     // console.log(res);
      //     if (this.isUpdate) {
      //       messagesNotifyHelper.updatedRecordNotify();
      //     } else {
      //       messagesNotifyHelper.createdRecordNotify();
      //       this.onBackPage();
      //     }
      //   })
      //   .catch((err) => console.log(err));
    },
    getDetails() {
      const params = new URLSearchParams();
      layoutService
        .getLayoutWdmaHistDetails(this.dataID, params)
        .then((res) => {
          // console.log(res);
          this.form._id = res._id;
          this.form.email = res.email;
          
          this.form.layout = res.layout ? JSON.stringify(res.layout) : '' ;
          this.form.metadata = res.metadata ? JSON.stringify(res.metadata) : '';
          this.form.layout_mobile = res.layout_mobile ? JSON.stringify(res.layout_mobile) : '';
          this.form.metadata_mobile = res.metadata_mobile ? JSON.stringify(res.metadata_mobile) : '';

          this.form.dt_create = convertDatetimeHelper.convertStringToDateTime(res.dt_create);
          this.form.dt_update = res.dt_update ? convertDatetimeHelper.convertStringToDateTime(res.dt_update) : res.dt_update;
          this.form.dt_delete = res.dt_delete ? convertDatetimeHelper.convertStringToDateTime(res.dt_delete) : res.dt_delete;
          this.form.email_create = res.email_create;
          this.form.email_update = res.email_update;
          this.form.email_delete = res.email_delete;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // loadData() {
    //   Promise.all([
    //     dropdownService.getAllLanguage(new URLSearchParams()),
    //     dropdownService.getAllCountries(new URLSearchParams()),
    //   ]).then((res) => {
    //       this.languages = res[0];
    //       this.wdmaRoutes = res[1];
    //       if (this.isUpdate) {
    //         this.getCountryDetails();
    //       }
    //     })
    //     .catch((err) => console.log(err));
    // },
  },
  components: {
    BButton,
    BRow,
    BCol,
    BFormInput,
    BForm,
    BTabs,
    BTab,
    BCard,
    BFormTextarea
  },
};
</script>

<style lang="scss">
.subject-badge-select {
  margin-bottom: 10px;
  .badge {
    margin: 0px 5px;
  }
}
</style>